import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiRequest } from "../../services/getApiRequest";
import { END_POINTS } from "../../Helper/Constant";
import { hideLoader, showLoader } from "../loader/loaderSlice";

export const fetchBanners = createAsyncThunk(
  "banner/fetchBanners",
  async (language = "en", {dispatch, rejectWithValue }) => {
    dispatch(showLoader());
    try {
      const res = await getApiRequest(
        `${END_POINTS.GET_BANNER}?lang=${language}`
      );
      if (res?.success) return res?.data?.products;
      return rejectWithValue(res?.message || "Failed to load banners");
    } catch (err) {
      return rejectWithValue(err.message);
    } finally {
      dispatch(hideLoader());
    }
  }
);

const bannerSlice = createSlice({
  name: "banner",
  initialState: { banners: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.loading = true;
        
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.loading = false;
        state.banners = action.payload;
        
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default bannerSlice.reducer;
